import { Outlet } from '@tanstack/react-router';

import { BlockedListTabs } from './components/BlockedListTabs/BlockedListTabs';

export function BlockedListLayout() {
  return (
    <div className="flex min-h-full min-w-0 flex-col">
      <BlockedListTabs />
      <div className="page-gutter min-w-0 flex-1 py-6">
        <Outlet />
      </div>
    </div>
  );
}
